<template>
  <v-card
    title="Quote"
    color="white"
    :class="`${getClass()}pointered`"
    class="px-2 py-1"
    v-if="editedOrder.currentPrice > 0"
    :flat="!fixed"
    @click.stop="cartClick"
  >
    <v-icon class="mt-4" :color="color">mdi-cart-outline</v-icon>
    <sup>
      <span class="price px-1 "> ${{ editedOrder.currentPrice.toFixed(2) }} </span>
    </sup>
  </v-card>

  <!-- <v-card
    :class="`${getClass()}pointered`"
    v-if="editedOrder.currentPrice>0"
    class="pr-5 pt-4"
    :flat="!fixed"
     @click="$vuetify.goTo(`#${target}`, {})"
  >
    <v-badge
    :color="`${color} lighten-1`"
    title="Current selected products price">
      <template v-slot:badge>${{editedOrder.currentPrice.toFixed(2)}}</template>
      <v-icon  :color="color">mdi-cart-outline</v-icon>
      <span class="title">{{"&nbsp;".repeat(editedOrder.currentPrice.toString().length-1)}}</span>
    </v-badge>
  </v-card> -->
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ShoppingCart',
  props: {
    fixed: {
      type: Boolean,
      required: false
    },
    color: {
      type: String,
      default: 'accent'
    },
    target: {
      type: String,
      default: 'orderComment'
    }
  },
  methods: {
    ...mapGetters('order', ['getEditedOrder']),
    getClass() {
      if (this.fixed) {
        return 'cart-badge '
      }
      return ''
    },
    cartClick() {
      if (this.$router.currentRoute.path != '/quote') {
        this.$router.push(`/quote`)
      } else {
        this.$vuetify.goTo(`#${this.target}`, {})
      }
    }
  },
  computed: {
    editedOrder() {
      return this.getEditedOrder()
    }
  }
}
</script>

<style lang="scss" scoped>
.price {
  margin-top: -30px;
  background-color: #8bb93e;
  opacity: 0.85;
  // border: 2px solid green;
  border-radius: 25px;
  color: white;
  // font-weight: bold;
  font-size: 100%;
}
.cart-badge {
  position: fixed;
  right: 25px;
  bottom: 25px;
  background-color: white;
  opacity: 0.85;
  // border: 2px solid green;
  border-radius: 25px;
  z-index: 100;
}
.pointered {
  cursor: pointer;
}
</style>
